export default async function fetchIfAuthorized<T>(
  url: string,
  init?: RequestInit,
): Promise<null | T> {
  try {
    const response = await fetch(url, init);
    if (!response.ok) {
      // In the review app the unauthorized requests return nothing as status text
      throw new Error(
        response.status === 401 ? "Unauthorized" : response.statusText,
      );
    }
    return await response.json();
  } catch (err) {
    if (err && err.name !== "AbortError" && err.message !== "Unauthorized") {
      // eslint-disable-next-line no-console
      console.error(err);
    }
    return null;
  }
}
